import { MadUI } from "../packages/mad-ui";
// import MadMoleculePopup from "../packages/mad-molecule-popup";
// import VueCodeHighlight from "vue-code-highlight";
// import "prism-es6/components/prism-markup";
// import VTooltip from "v-tooltip";
// import "@/assets/duotone-sea.css";
import { register } from "./languageHub";

export default Vue => {
  // Vue.use(VTooltip);
  Vue.use(MadUI);
  register(Vue);
  // Vue.use(MadMoleculePopup);
  // Vue.use(VueCodeHighlight);
};
